import {
    ON_START_FETCH_VUNNEN_MONTH,
    ON_FETCH_VUNNEN_MONTH,
    ON_ERROR_FETCH_VUNNEN_MONTH,
    ON_START_FETCH_AVSLUTA_AFFAR,
    ON_FETCH_AVSLUTA_AFFAR,
    ON_ERROR_FETCH_AVSLUTA_AFFAR,
    ON_START_FETCH_DASHORDER_LIST,
    ON_FETCH_DASHORDER_LIST,
    ON_ERROR_FETCH_DASHORDER_LIST,
    ON_START_FETCH_MOTE_MONTH,
    ON_FETCH_MOTE_MONTH,
    ON_ERROR_FETCH_MOTE_MONTH,ON_START_FETCH_DASHBOARD_ORDER_FILTER,SET_DASHBORD_PROSPEKT_FILTER,SET_DASHBORD_PULS_FILTER,
    ON_START_GET_LOBBY_CUSTOM, ON_GET_LOBBY_CUSTOM, ON_ERROR_GET_LOBBY_CUSTOM,
    ON_START_UPDATE_LOBBY_CUSTOM,ON_UPDATE_LOBBY_CUSTOM,ON_ERROR_UPDATE_LOBBY_CUSTOM,
    SET_DASHBORD_KONTOR_FILTER,
    ON_START_FETCH_DASHBOARD_KONTOR_FILTER,ON_FETCH_DASHBOARD_KONTOR_FILTER,ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER,
    
    ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER,
		ON_FETCH_TOTAL_SALES, ON_ERROR_FETCH_TOTAL_SALES,ON_START_FETCH_TOTAL_SALES,
		ON_FETCH_MRR, ON_ERROR_FETCH_MRR,ON_START_FETCH_MRR,
		ON_FETCH_ARR, ON_ERROR_FETCH_ARR, ON_START_FETCH_ARR,
		ON_FETCH_ARPU, ON_ERROR_FETCH_ARPU, ON_START_FETCH_ARPU,

    ON_START_FETCH_NYKUND_MOTE, ON_FETCH_NYKUND_MOTE, ON_ERROR_FETCH_NYKUND_MOTE,
    ON_START_FETCH_NYUPPKUND_MOTE, ON_FETCH_NYUPPKUND_MOTE, ON_ERROR_FETCH_NYUPPKUND_MOTE,
    ON_START_FETCH_BEFKUND_MOTE, ON_FETCH_BEFKUND_MOTE, ON_ERROR_FETCH_BEFKUND_MOTE,
    ON_START_FETCH_AVBOKA_MOTE, ON_FETCH_AVBOKA_MOTE, ON_ERROR_FETCH_AVBOKA_MOTE,
    ON_START_FETCH_GENOM_MOTE, ON_FETCH_GENOM_MOTE, ON_ERROR_FETCH_GENOM_MOTE,
    ON_START_FETCH_SUMMA_OFFERT_MONTH, ON_FETCH_SUMMA_OFFERT_MONTH, ON_ERROR_FETCH_SUMMA_OFFERT_MONTH,
    ON_START_FETCH_SKAPAD_PROSPEKT_MONTH, ON_FETCH_SKAPAD_PROSPEKT_MONTH, ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH,
    ON_START_FETCH_AKTIVA_AVTAL,ON_FETCH_AKTIVA_AVTAL,ON_ERROR_FETCH_AKTIVA_AVTAL,
    ON_START_FETCH_AVTALINVOICING_TABLE_ABONN, ON_FETCH_AVTALINVOICING_TABLE_ABONN, ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN,
    ON_START_FETCH_AVTAL_TABLE_ABONN,ON_FETCH_AVTAL_TABLE_ABONN,ON_ERROR_FETCH_AVTAL_TABLE_ABONN,
    ON_START_FETCH_AVTAL_TABLE_ALL,ON_FETCH_AVTAL_TABLE_ALL,ON_ERROR_FETCH_AVTAL_TABLE_ALL,
    ON_START_FETCH_AVTAL_TABLE_ENGÅNG,ON_FETCH_AVTAL_TABLE_ENGÅNG,ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG,
    ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING,
    ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING,
    ON_START_FETCH_KLARA_AKTIVITET_MONTH, ON_FETCH_KLARA_AKTIVITET_MONTH, ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH,
    ON_START_FETCH_ORDER_VUNNEN_MONTH,  ON_FETCH_ORDER_VUNNEN_MONTH, ON_ERROR_FETCH_ORDER_VUNNEN_MONTH,
    ON_START_FETCH_ABO_VUNNEN_MONTH,ON_FETCH_ABO_VUNNEN_MONTH,ON_ERROR_FETCH_ABO_VUNNEN_MONTH,
    ON_START_FETCH_ABON_VUNNEN_MONTH,
    ON_FETCH_ABON_VUNNEN_MONTH,
    ON_ERROR_FETCH_ABON_VUNNEN_MONTH,
    ON_START_FETCH_VUNNEN_CHART,ON_FETCH_VUNNEN_CHART,ON_ERROR_FETCH_VUNNEN_CHART,
    ON_FETCH_SUMMA_BILLING_AVTAL, ON_ERROR_FETCH_SUMMA_BILLING_AVTAL, ON_START_FETCH_SUMMA_BILLING_AVTAL,
    ON_FETCH_SUMMA_ABONNEMANG_AVTAL, ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL, ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL,
    ON_START_FETCH_VUNNEN_MONTH_CHART,ON_FETCH_VUNNEN_MONTH_CHART,ON_ERROR_FETCH_VUNNEN_MONTH_CHART,
    ON_START_FETCH_AKTIVITITER_CHART,ON_FETCH_AKTIVITITER_CHART,ON_ERROR_FETCH_AKTIVITITER_CHART,
    ON_ClOSE_FILTER_DASHBOARD,ON_OPEN_FILTER_DASHBOARD,SET_DASHBORD_FILTER,SET_DASHBORD_SALJ_FILTER,SET_DASHBORD_ANPASSAD_FILTER,
    SET_DASHBORD_ORDER_FILTER,ON_OPEN_FILTER_DASHBOARD_ORDER,ON_ClOSE_FILTER_DASHBOARD_ORDER,
    ON_START_FETCH_DASHBOARD_FILTER,ON_FETCH_DASHBOARD_FILTER,ON_ERROR_FETCH_DASHBOARD_FILTER,
    ON_START_FETCH_BESTLIST_DIALER_BYAFID,ON_FETCH_BESTLIST_DIALER_BYAFID,ON_ERROR_BESTLIST_DIALER_BYAFID,
    ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID,ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID,ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID,
    ON_START_FETCH_BOKAMOTE_DIALER_BYAFID,ON_FETCH_BOKAMOTE_DIALER_BYAFID,ON_ERROR_BOKAMOTE_DIALER_BYAFID,
    ON_START_FETCH_SALTABLE_DIALER_BYAFID,ON_FETCH_SALTABLE_DIALER_BYAFID,ON_ERROR_SALTABLE_DIALER_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_BYAFID,ON_FETCH_LYNES_SAMTAL_BYAFID,ON_ERROR_LYNES_SAMTAL_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID,ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID,ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID,ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID,ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID, ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID, ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_GRAPH_BYAFID, ON_FETCH_LYNES_SAMTAL_GRAPH_BYAFID, ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID,
    ON_START_FETCH_AVSLUT_DIALER_BYAFID,ON_FETCH_AVSLUT_DIALER_BYAFID,ON_ERROR_AVSLUT_DIALER_BYAFID,
    ON_START_FETCH_STATUS_DIALER_BYAFID,ON_FETCH_STATUS_DIALER_BYAFID,ON_ERROR_STATUS_DIALER_BYAFID,
    ON_START_FETCH_AKTIVITED_DIALER_BYAFID,ON_FETCH_AKTIVITED_DIALER_BYAFID,ON_ERROR_AKTIVITED_DIALER_BYAFID,
    ON_START_FETCH_TOPLIST_SAL_BYAFID,ON_FETCH_TOPLIST_SAL_BYAFID,ON_ERROR_TOPLIST_SAL_BYAFID,
    ON_START_FETCH_TOPLIST_SALANTAL_BYAFID,ON_FETCH_TOPLIST_SALANTAL_BYAFID,ON_ERROR_TOPLIST_SALANTAL_BYAFID,
    ON_START_FETCH_AFFAR_SALANTAL_BYAFID,ON_FETCH_AFFAR_SALANTAL_BYAFID,ON_ERROR_AFFAR_SALANTAL_BYAFID,
    ON_START_FETCH_AFFAR_SAL_BYAFID,ON_FETCH_AFFAR_SAL_BYAFID,ON_ERROR_AFFAR_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID ,ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID, ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,
    ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID,
    ON_START_FETCH_TOPLIST_BOK_BYAFID,ON_FETCH_TOPLIST_BOK_BYAFID,ON_ERROR_TOPLIST_BOK_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID,ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID,ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G,
    ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID,
    ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID,
    ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID,
    ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID,

    ON_START_FETCH_ANTAL_BOK_BYAFID,ON_FETCH_ANTAL_BOK_BYAFID,ON_ERROR_ANTAL_BOK_BYAFID,
    ON_START_FETCH_TABEL_BOK_BYAFID,ON_FETCH_TABEL_BOK_BYAFID,ON_ERROR_TABEL_BOK_BYAFID,
    ON_START_FETCH_MONTH_PROSPEKTD_BYAFID,ON_FETCH_MONTH_PROSPEKTD_BYAFID,ON_ERROR_MONTH_PROSPEKTD_BYAFID,
    ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_ERROR_KVARTAL_PROSPEKTD_BYAFID,
    ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID,ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID,ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID,
    ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID,ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID,ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID,
    ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID,ON_FETCH_PIPELINE_PROSPEKTD_BYAFID,ON_ERROR_PIPELINE_PROSPEKTD_BYAFID,
    ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID,ON_FETCH_UTFALL_PROSPEKTD_BYAFID,ON_ERROR_UTFALL_PROSPEKTD_BYAFID,
    ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_ERROR_AVTAL_VALUE_YEAR_BYAFID,
    ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID,
    ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID,
    ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID,ON_FETCH_UTFALLS_PROSPEKTD_BYAFID,ON_ERROR_UTFALLS_PROSPEKTD_BYAFID,
    ON_START_FETCH_UTFALL_BOK_BYAFID,ON_FETCH_UTFALL_BOK_BYAFID,ON_ERROR_UTFALL_BOK_BYAFID,SET_ZERO_DASHBOARD,
    ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_ERROR_UTFALL_BOK_BUDGET_BYAFID,
    ON_START_FETCH_TOPLIST_KONTOR_BYAFID, ON_FETCH_TOPLIST_KONTOR_BYAFID, ON_ERROR_TOPLIST_KONTOR_BYAFID,    
    ON_START_FETCH_LIST_KONTOR_BYAFID, ON_FETCH_LIST_KONTOR_BYAFID, ON_ERROR_LIST_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLS_KONTOR_BYAFID, ON_FETCH_UTFALLS_KONTOR_BYAFID, ON_ERROR_UTFALLS_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID, ON_FETCH_UTFALLSPRO_KONTOR_BYAFID, ON_ERROR_UTFALLSPRO_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID, ON_FETCH_UTFALLSORD_KONTOR_BYAFID, ON_ERROR_UTFALLSORD_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID, ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID, ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID, ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID, ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID,
    ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID, ON_FETCH_LASTVUNNEN_KONTOR_BYAFID, ON_ERROR_LASTVUNNEN_KONTOR_BYAFID,
    ON_START_FETCH_BOKADE_KONTOR_BYAFID, ON_FETCH_BOKADE_KONTOR_BYAFID, ON_ERROR_BOKADE_KONTOR_BYAFID,
    ON_START_FETCH_COUNT_OFFERT_MONTH, ON_FETCH_COUNT_OFFERT_MONTH, ON_ERROR_FETCH_COUNT_OFFERT_MONTH,
    ON_START_FETCH_COUNT_ARENDE_NY_MONTH, ON_FETCH_COUNT_ARENDE_NY_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH,
    ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH, ON_FETCH_COUNT_ARENDE_KLARA_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH,
    ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH, ON_FETCH_COUNT_ARENDE_OPPNA_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH,
    ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST,ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST,ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST,
    ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,
    ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR,
    ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,
    ON_START_FETCH_COUNT_LAST_ARENDE, ON_FETCH_COUNT_LAST_ARENDE, ON_ERROR_FETCH_COUNT_LAST_ARENDE,
    ON_FETCH_PROJECT_WORKLOAD,ON_START_FETCH_PROJECT_WORKLOAD,ON_ERROR_FETCH_PROJECT_WORKLOAD, 
    ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED, ON_FETCH_PROJECT_CREATEDVSCOMPLETED, ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED, 
    ON_START_FETCH_PROJECT_TASKS, ON_FETCH_PROJECT_TASKS, ON_ERROR_FETCH_PROJECT_TASKS,
    ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL, ON_FETCH_PROJECT_STATUS_LIST_ANTAL, ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL,
    ON_START_FETCH_PROJECT_KLARA_KORT_TM,ON_FETCH_PROJECT_KLARA_KORT_TM,ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM,
    ON_START_FETCH_PROJECT_KORT_KVAR_TM,ON_FETCH_PROJECT_KORT_KVAR_TM,ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM,
    ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL,
    ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL,
    ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL,
    ON_OPEN_FILTER_DASHBOARD_SALJ,
    ON_ClOSE_FILTER_DASHBOARD_SALJ, 
    ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER, ON_FETCH_DASHBOARD_SALJ_FILTER, ON_START_FETCH_DASHBOARD_SALJ_FILTER,
    ON_START_FETCH_DASHBOARD_BOKA_FILTER,ON_FETCH_DASHBOARD_BOKA_FILTER,ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER,
    ON_FETCH_DASHBOARD_ORDER_FILTER,ON_FETCH_DASHBOARD_BARN_FILTER,
    ON_START_FETCH_DASHBOARD_DIALER_FILTER, ON_FETCH_DASHBOARD_DIALER_FILTER, ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER,
    ON_START_FETCH_PROJECT_TIMESPENT, ON_FETCH_PROJECT_TIMESPENT, ON_ERROR_FETCH_PROJECT_TIMESPENT,
    ON_START_FETCH_PROJECT_AHEAD_BEHIND, ON_FETCH_PROJECT_AHEAD_BEHIND, ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND,
    ON_ClOSE_FILTER_DASHBOARD_BOKA,ON_OPEN_FILTER_DASHBOARD_BOKA,SET_DASHBORD_BOKA_FILTER,
    ON_ClOSE_FILTER_DASHBOARD_DIALER,SET_DASHBORD_DIALER_FILTER,ON_OPEN_FILTER_DASHBOARD_DIALER,
    ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_ERROR_ORDERTYPE_ANTAL_BYAFID,
    ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID,
    ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID ,ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID, ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID,
    ON_START_FETCH_AVTAL_GROWTH_BYAFID, ON_FETCH_AVTAL_GROWTH_BYAFID, ON_ERROR_AVTAL_GROWTH_BYAFID,
    ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID, ON_FETCH_ARTIKLAR_ANTAL_BYAFID, ON_ERROR_ARTIKLAR_ANTAL_BYAFID,
    ON_START_FETCH_NY_ORDER_ANTAL_BYAFID, ON_FETCH_NY_ORDER_ANTAL_BYAFID, ON_ERROR_NY_ORDER_ANTAL_BYAFID,
    ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID,
    ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID, ON_FETCH_STATUS_ORDER_ANTAL_BYAFID, ON_ERROR_STATUS_ORDER_ANTAL_BYAFID,
    ON_START_FETCH_STATUS_HAS_ABONN, ON_FETCH_STATUS_HAS_ABONN, ON_ERROR_STATUS_HAS_ABONN,
    ON_START_FETCH_STATUS_HAS_ORERV,ON_FETCH_STATUS_HAS_ORERV,ON_ERROR_STATUS_HAS_ORERV, 
    ON_START_FETCH_ORDER_VARDE_YEAR, ON_FETCH_ORDER_VARDE_YEAR, ON_ERROR_ORDER_VARDE_YEAR,
    ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID,
    ON_START_FETCH_LIST_CHILD_KONTO_BYAFID, ON_FETCH_LIST_CHILD_KONTO_BYAFID, ON_ERROR_LIST_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID,
    ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID,
    ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID,
    ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID, ON_FETCH_BOKADE_CHILD_KONTO_BYAFID, ON_ERROR_BOKADE_CHILD_KONTO_BYAFID,
    ON_OPEN_FILTER_DASHBOARD_BARN,ON_ClOSE_FILTER_DASHBOARD_BARN,SET_DASHBORD_BARN_FILTER,
    ON_OPEN_FILTER_DASHBOARD_PROSPEKT,ON_ClOSE_FILTER_DASHBOARD_PROSPEKT,
    ON_OPEN_FILTER_DASHBOARD_PULS,ON_ClOSE_FILTER_DASHBOARD_PULS,
    ON_OPEN_FILTER_DASHBOARD_KONTOR,ON_ClOSE_FILTER_DASHBOARD_KONTOR,
    ON_START_GET_DASHBOARD_CUSTOM_LIST,
    ON_GET_DASHBOARD_CUSTOM_LIST,
    ON_ERROR_GET_DASHBOARD_CUSTOM_LIST,
    ON_START_ADD_DASHBOARD_CUSTOM,
    ON_ADD_DASHBOARD_CUSTOM,
    ON_ERROR_ADD_DASHBOARD_CUSTOM,
    ON_START_REMOVE_DASHBOARD_CUSTOM,
    ON_REMOVE_DASHBOARD_CUSTOM,
    ON_ERROR_REMOVE_DASHBOARD_CUSTOM,
    ON_START_GET_DASHBOARD_CUSTOM,
    ON_GET_DASHBOARD_CUSTOM,
    ON_ERROR_GET_DASHBOARD_CUSTOM,
    ON_START_UPDATE_DASHBOARD_CUSTOM,
    ON_UPDATE_DASHBOARD_CUSTOM,
    ON_ERROR_UPDATE_DASHBOARD_CUSTOM,
    ON_START_DELETE_DASHBOARD_CUSTOM,
    ON_DELETE_DASHBOARD_CUSTOM,
    ON_ERROR_DELETE_DASHBOARD_CUSTOM,

    ON_START_GET_DASHBOARD_COMPETITION_LIST,
    ON_GET_DASHBOARD_COMPETITION_LIST,
    ON_ERROR_GET_DASHBOARD_COMPETITION_LIST,
    ON_START_ADD_DASHBOARD_COMPETITION,
    ON_ADD_DASHBOARD_COMPETITION,
    ON_ERROR_ADD_DASHBOARD_COMPETITION,
    ON_START_REMOVE_DASHBOARD_COMPETITION,
    ON_REMOVE_DASHBOARD_COMPETITION,
    ON_ERROR_REMOVE_DASHBOARD_COMPETITION,
    ON_START_GET_DASHBOARD_COMPETITION,
    ON_GET_DASHBOARD_COMPETITION,
    ON_ERROR_GET_DASHBOARD_COMPETITION,
    ON_START_UPDATE_DASHBOARD_COMPETITION,
    ON_UPDATE_DASHBOARD_COMPETITION,
    ON_ERROR_UPDATE_DASHBOARD_COMPETITION,
    ON_START_DELETE_DASHBOARD_COMPETITION,
    ON_DELETE_DASHBOARD_COMPETITION,
    ON_ERROR_DELETE_DASHBOARD_COMPETITION,
    ON_POST_CHAT_DASHBOARD_COMPETITION,
    ON_START_POST_CHAT_DASHBOARD_COMPETITION,
    ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION,

    // ON_START_GET_DASHBOARD_NOTIS,
    // ON_GET_DASHBOARD_NOTIS,
    // ON_ERROR_GET_DASHBOARD_NOTIS,
    // ON_START_SET_DASHBOARD_NOTIS_SEEN,
    // ON_SET_DASHBOARD_NOTIS_SEEN,
    // ON_ERROR_SET_DASHBOARD_NOTIS_SEEN,

    ON_START_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_START_ADD_DASHBOARD_TV_DEVICE ,
    ON_ADD_DASHBOARD_TV_DEVICE,
    ON_ERROR_ADD_DASHBOARD_TV_DEVICE ,
    ON_START_REMOVE_DASHBOARD_TV_DEVICE,
    ON_REMOVE_DASHBOARD_TV_DEVICE,
    ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE,
    ON_START_CONNECT_DASHBOARD_TV_DEVICE ,
    ON_CONNECT_DASHBOARD_TV_DEVICE ,
    ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE ,
    ON_START_INIT_DASHBOARD_TV_DEVICE,
    ON_INIT_DASHBOARD_TV_DEVICE,
    ON_ERROR_INIT_DASHBOARD_TV_DEVICE,

    ON_START_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY,
    ON_UPDATE_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY,
} from "../constants/ActionTypes";
import {isUndefined} from 'lodash'
 
const INIT_STATE = {
    CustomDashboardLoading: false,
    MyLobby:{},
    CustomDashboardList: [],    
    currentCustomDashboard:{},
    DashboardCompetitionLoading: false,
    DashboardCompetitionList: [],
    currentDashboardCompetition:{},
    dashboardTVDevices:[],
    DashboardDeviceLoading: false,
    DashboardDeviceErrorMsg: '',
    DashboardTVDeviceConnection: {},
    VunnenMonth:0,
    TB1MonthVunnen:0,
    VunnenYear:0,
    VunnenYearTB:0,
    StartMonth:'January',
    VunnenChart:[],
    OrderVarde:0,
    AbonnemangVarde:0,
    MonthVunnen:0,
    UserBudget:0,
    BokadMote:0,
    CountOffert:0,
    CountArendenNya: 0,
    CountArendenKlara: 0,
    CountArendenOppna: 0,
    ArendeTopOppnaList:[],
    ArendeOppnaPagaende:[],
    ArendenNyaStangdaYear:[],
    AvtalLoperUtOmForYear:[],
    LastArenden:[],
    Offert:0,
    Hitrate:0,
    SummaOffert:{Bas:0,Month:0},
    AktiverKunder:0,
    BokadMote:0,
    OrdervardeBudget:0,
    VunnAffarAntalSal:0,
    VunnAffarSal:0,
    VunnAffarSal2:0,
    VunnAffarSalProb:0,
    VunnAffarSalProbBudget:0,
    VunnAffarSalAvtal:0,
    VunnAffarSalAvtalBilling:0,
    VunnAvtalBillingYear:0,
    SenasteVunnenVAvtal:0,
    VunnAffarSalAvtalBudget:0,
    BokmoteAntalSal:0,
    BokmoteAntalSalFram:0,
    BokmoteAntalSalBack:0,
    AvslutaAffar:[],
    DashOrderList:[],
    AktiviterArr:[],
    currentuser:{},
    Bokacurrentuser:{},
    saljcurrentuser:{},
    Ordercurrentuser:{},
    Prospektcurrentuser:{},
    Kontocurrentuser:{},
    StatusTabel:{},
    BestListDialer:[],
    AktiviterDailer:[],
    SalTabel:[],
    TopListSal:[],
    TopListSalProb:[],
    TopListSalAntal:[],
    TopListBokning:[],
    TopListBokAntal:[],
    TopListBokAntalG:[],
    BokadeMotenBokadAv:[],
    BokadeMotenBokadTill:[],
    AvBokadeMotenBokadAv:[],
    AvBokadeMotenBokadTill:[],
    TopListBokAntalB:[],
    BokningTable:[],
    AvslutaAffarList:[],
    VunnenListP:[],
    ProspektPipeline:[],
    utFallPros:[],
    utFallProsProb:[],
    AvtalVardeYear:[],
    utFallProsAntal:[],
    TopListKon:[],
    TopListChildKon:[],
    LynesSamtalTable:[],
    LynesSamtalAntal:0,
    LynesAvgDurLength:0,
    LynesLastSamtalTable:[],
    LynesLastSamtalGraph:[],
    SummaBillingAvtal: 0,
    SummaAbonnAvtal: 0,
    TopListKontorBarn:[],
    TopListKontor:[],
    ProjectWorkload:[],
    ProjectCreatedVsCompleted:[],
    ProjectTasks:[],
    ProjectTimeSpent:[],
    ProjectAheadBehind:[],
    ProjectStatusAntalList:[],
    ProjectDeadlineAntalList:[],
    AntalKortKlara:0,
    AntalKortKvar:0,
    Utfalldiagram:{GMote:0,Total:100},
    UtfallSdiagram:{utfall:0,budget:100},
    UtfallBMdiagram:{utfall:0,budget:100},
    MonthVunneProspekt:{monthV:0,monthTBV:0,monthB:100},
    KvartalVunneProspekt:{KvartalV:0,KvartaTBV:0,KvartalB:100},
    FilterDashbordPopup:false,
    FilterDashbordSaljPopup:false,
    FilterDashbordBokaPopup:false,
    FilterDashbordDialerPopup:false,
    FilterDashbordOrderPopup:false,
    FilterDashbordBarnPopup:false,
    FilterDashbordProspektPopup:false,
    FilterDashbordPulsPopup:false,
    FilterDashbordKontorPopup:false,
    KlaraAkt:0,
    SkProspekt:0,
    AkAvtal:0,
    AAVBINTableMonthly:[],
    AAVBTableMonthly:[],
    AAVBTableEngang:[],
    AAVGraphRemaining: [],
    AAVSumRemaining: 0,
    GnomMote:0,
    BefMote:0,
    NYMote:0,
    NYUppMote:0,
    UserMoteBudget:0,
    UtfallSdiagramKontor:[{utfall:0,budget:100}],
    UtfallSdiagramKontoChild:[{utfall:0,budget:100}],
    UtfallSdiagramProsKontor:[{utfall:0,budget:100}],
    UtfallSdiagramBarnProsKontor:[{utfall:0,budget:100}],
    UtfallSdiagramBarnOrderKontor:[{utfall:0,budget:100}],
    UtfallSdiagramOrderKontor:[{utfall:0,budget:100}],
    UtfallSdiagramKlarAkt:[{utfall:0,budget:100}],
    UtfallSdiagramNOffertKontor:[{utfall:0,budget:100}],
    UtfallSdiagramBmoteKontor:[{utfall:0,budget:100}],
    UtfallSdiagramBmoteBarnKontor:[{utfall:0,budget:100}],
    LastVunnenKontor:[],
    LastVunnenChildKontor:[],
    LastBokadeKontor:[],
    LastBokadeChildKontor:[],
    SenasteVunnen:{},
    SenasteVunnenV:{},
    SenasteVunnenVProb:{},
    SenasteBokmote:{},
    OrderTypeAntal:[],
    ProspektTypeAntal:[],
    AvtalTypeAntal:[],
    AvtalGrowth: [],
    ArtiklarAntal:[],
    OrderStatusAntalList:[],
    OrderVardeList:[],
    AntalNyaOrder:0,
    TotaltOrderArtiklar:0,
    AfidHasAbon:0,
    AfidHasOrderVarde:0,
    TopListChildKon:[],
    SummaBillingAvtal: 0,
    SummaAbonnAvtal: 0,
		TotalSalesValue: 0,
		MRRValue: 0,
		ARRValue: 0,
		ARPUValue: 0,
    DashboardFilterOption:isUndefined(localStorage.DashboardFilter)?[]:JSON.parse(localStorage.DashboardFilter), 
    DashboardAnpassadFilterOption:isUndefined(localStorage.DashboardAnpassadFilter)?[]:JSON.parse(localStorage.DashboardAnpassadFilter), 
    DashboardSaljFilterOption:isUndefined(localStorage.DashboardSaljFilter)?[]:JSON.parse(localStorage.DashboardSaljFilter), 
    DashboardBokaFilterOption:isUndefined(localStorage.DashboardBOKAFilter)?[]:JSON.parse(localStorage.DashboardBOKAFilter), 
    DashboardDialerFilterOption:isUndefined(localStorage.DashboardDIALERFilter)?[]:JSON.parse(localStorage.DashboardDIALERFilter), 
    DashboardOrderFilterOption:isUndefined(localStorage.DashboardOrderFilter)?[]:JSON.parse(localStorage.DashboardOrderFilter), 
    DashboardBarnFilterOption:isUndefined(localStorage.DashboardBarnFilter)?[]:JSON.parse(localStorage.DashboardBarnFilter), 
    DashboardProspektFilterOption:isUndefined(localStorage.DashboardProspektFilter)?[]:JSON.parse(localStorage.DashboardProspektFilter), 
    DashboardPulsFilterOption:isUndefined(localStorage.DashboardPulsFilter)?[]:JSON.parse(localStorage.DashboardPulsFilter), 
    DashboardKontorFilterOption:isUndefined(localStorage.DashboardKontorFilter)?[]:JSON.parse(localStorage.DashboardKontorFilter), 
    nextReq:true,
    reloadData:false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_ZERO_DASHBOARD:{
           return INIT_STATE;
          }
        case ON_START_FETCH_VUNNEN_MONTH_CHART:{
            console.log("ON_START_FETCH_VUNNEN_MONTH_CHART",action)
            return {
                ...state,
                nextReq:false
            }
        }
        case ON_ClOSE_FILTER_DASHBOARD:{
            console.log("ON_ClOSE_FILTER_DASHBOARD",action)
            return {
              ...state,
              FilterDashbordPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_SALJ:{
            console.log("ON_ClOSE_FILTER_DASHBOARD",action)
            return {
              ...state,
              FilterDashbordSaljPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_BOKA:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_BOKA",action)
            return {
              ...state,
              FilterDashbordBokaPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_DIALER:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_DIALER",action)
            return {
              ...state,
              FilterDashbordDialerPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_ORDER:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_ORDER",action)
            return {
              ...state,
              FilterDashbordOrderPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_BARN:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_ORDER",action)
            return {
              ...state,
              FilterDashbordBarnPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_PROSPEKT:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_PROSPEKT",action)
            return {
              ...state,
              FilterDashbordProspektPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_PULS:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_PULS",action)
            return {
              ...state,
              FilterDashbordPulsPopup:false
            }
          }
        case ON_ClOSE_FILTER_DASHBOARD_KONTOR:{
            console.log("ON_ClOSE_FILTER_DASHBOARD_KONTOR",action)
            return {
              ...state,
              FilterDashbordKontorPopup:false
            }
          }
          case SET_DASHBORD_FILTER: {
            console.log("SET_DASHBORD_FILTER",action.payload)
            localStorage.removeItem("DashboardFilter");
            localStorage.setItem("DashboardFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardFilterOption: action.payload
            };
          }
          case SET_DASHBORD_ANPASSAD_FILTER: {
            console.log("SET_DASHBORD_ANPASSAD_FILTER",action.payload)
            localStorage.removeItem("DashboardAnpassadFilter");
            localStorage.setItem("DashboardAnpassadFilter", JSON.stringify(action.payload));
            return { ...state,
              DashboardAnpassadFilterOption: action.payload
            };
          }
          case SET_DASHBORD_SALJ_FILTER: {
            console.log("SET_DASHBORD_SALJ_FILTER",action.payload)
            localStorage.removeItem("DashboardSaljFilter");
            localStorage.setItem("DashboardSaljFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardSaljFilterOption: action.payload
            };
          }
          case SET_DASHBORD_BOKA_FILTER: {
            console.log("SET_DASHBORD_BOKA_FILTER",action.payload)
            localStorage.removeItem("DashboardBOKAFilter");
            localStorage.setItem("DashboardBOKAFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardBokaFilterOption: action.payload
            };
          }
          case SET_DASHBORD_ORDER_FILTER: {
            console.log("SET_DASHBORD_ORDER_FILTER",action.payload)
            localStorage.removeItem("DashboardOrderFilter");
            localStorage.setItem("DashboardOrderFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardOrderFilterOption: action.payload
            };
          }
          case SET_DASHBORD_BARN_FILTER: {
            console.log("SET_DASHBORD_BARN_FILTER",action.payload)
            localStorage.removeItem("DashboardBarnFilter");
            localStorage.setItem("DashboardBarnFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardBarnFilterOption: action.payload
            };
          }
          case SET_DASHBORD_PROSPEKT_FILTER: {
            console.log("SET_DASHBORD_PROSPEKT_FILTER",action.payload)
            localStorage.removeItem("DashboardProspektFilter");
            localStorage.setItem("DashboardProspektFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardProspektFilterOption: action.payload
            };
          }
          case SET_DASHBORD_PULS_FILTER: {
            console.log("SET_DASHBORD_PULS_FILTER",action.payload)
            localStorage.removeItem("DashboardPulsFilter");
            localStorage.setItem("DashboardPulsFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardPulsFilterOption: action.payload
            };
          }
          case SET_DASHBORD_KONTOR_FILTER: {
            console.log("SET_DASHBORD_KONTOR_FILTER",action.payload)
            localStorage.removeItem("DashboardKontorFilter");
            localStorage.setItem("DashboardKontorFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardKontorFilterOption: action.payload
            };
          }
          case SET_DASHBORD_DIALER_FILTER: {
            console.log("SET_DASHBORD_DIALER_FILTER",action.payload)
            localStorage.removeItem("DashboardDIALERFilter");
            localStorage.setItem("DashboardDIALERFilter", JSON.stringify(action.payload));
            return { ...state,
                DashboardDialerFilterOption: action.payload
            };
          }
        case ON_OPEN_FILTER_DASHBOARD:{
            console.log("ON_OPEN_FILTER_DASHBOARD",action)
            return {
              ...state,
              FilterDashbordPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_SALJ:{
            console.log("ON_OPEN_FILTER_DASHBOARD_SALJ",action)
            return {
              ...state,
              FilterDashbordSaljPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_BOKA:{
            console.log("ON_OPEN_FILTER_DASHBOARD_BOKA",action)
            return {
              ...state,
              FilterDashbordBokaPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_DIALER:{
            console.log("ON_OPEN_FILTER_DASHBOARD_DIALER",action)
            return {
              ...state,
              FilterDashbordDialerPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_ORDER:{
            console.log("ON_OPEN_FILTER_DASHBOARD_ORDER",action)
            return {
              ...state,
              FilterDashbordOrderPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_BARN:{
            console.log("ON_OPEN_FILTER_DASHBOARD_BARN",action)
            return {
              ...state,
              FilterDashbordBarnPopup:true
            }
          }
        //ON_ClOSE_FILTER_DASHBOARD_KONTOR,
        case ON_OPEN_FILTER_DASHBOARD_KONTOR:{
            console.log("ON_OPEN_FILTER_DASHBOARD_KONTOR",action)
            return {
              ...state,
              FilterDashbordKontorPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_PROSPEKT:{
            console.log("ON_OPEN_FILTER_DASHBOARD_PROSPEKT",action)
            return {
              ...state,
              FilterDashbordProspektPopup:true
            }
          }
        case ON_OPEN_FILTER_DASHBOARD_PULS:{
            console.log("ON_OPEN_FILTER_DASHBOARD_PULS",action)
            return {
              ...state,
              FilterDashbordPulsPopup:true
            }
          }
        case ON_FETCH_VUNNEN_MONTH_CHART:{
            console.log("ON_FETCH_VUNNEN_MONTH_CHART",action)
            return {
                ...state,
                MonthVunnen:action.payload.MonthVunnen,
                TB1MonthVunnen:action.payload.TB1MonthVunnen,
                UserBudget:action.payload.UserBudget,
            }
        }
        case ON_ERROR_FETCH_VUNNEN_MONTH_CHART:{
            console.log("ON_ERROR_FETCH_VUNNEN_MONTH_CHART",action)
            return {
                ...state
            }
        }


       case ON_START_FETCH_VUNNEN_CHART:{
            console.log("ON_START_FETCH_VUNNEN_CHART",action)
            return {
                ...state
            }
        }
        case ON_FETCH_VUNNEN_CHART:{
            console.log("ON_FETCH_VUNNEN_CHART",action)
            return {
                ...state,
                VunnenChart:action.payload.VunnenChart,
                VunnenYear:action.payload.VunnenYear,
                VunnenYearTB:action.payload.VunnenYearTB,
                StartMonth:action.payload.StartMonth
            }
        }
        case ON_ERROR_FETCH_VUNNEN_CHART:{
            console.log("ON_ERROR_FETCH_VUNNEN_CHART",action)
            return {
                ...state
            }
        }
        
        case ON_FETCH_SUMMA_BILLING_AVTAL: {
          console.log("ON_FETCH_SUMMA_BILLING_AVTAL", action.payload)
          return {
            ...state,
            SummaBillingAvtal: action.payload.SummaBillingAvtal,
          }
        }
        case ON_ERROR_FETCH_SUMMA_BILLING_AVTAL: {
          console.log("ON_ERROR_FETCH_SUMMA_BILLING_AVTAL", action.payload)
          return {
            ...state,
          }
        }
        case ON_START_FETCH_SUMMA_BILLING_AVTAL: {
          console.log("ON_START_FETCH_SUMMA_BILLING_AVTAL", action.payload)
          return {
            ...state,
          }
        }
        
				case ON_FETCH_TOTAL_SALES: {
					console.log("ON_FETCH_TOTAL_SALES", action.payload)
					return {
						...state,
						TotalSalesValue: action.payload.TotalSalesValue
					}
				}
				case ON_ERROR_FETCH_TOTAL_SALES: {
					console.log("ON_ERROR_FETCH_TOTAL_SALES", action.payload)
					return {
						...state,
					}
				}
				case ON_START_FETCH_TOTAL_SALES: {
					console.log("ON_START_FETCH_TOTAL_SALES", action.payload)
					return {
						...state,
					}
				}
				case ON_FETCH_MRR: {
					console.log("ON_FETCH_MRR", action.payload)
					return {
						...state,
						MRRValue: action.payload.SummaBillingAvtal
					}
				}
				case ON_ERROR_FETCH_MRR: {
					console.log("ON_ERROR_FETCH_MRR", action.payload)
					return {
						...state,
					}
				}
				case ON_START_FETCH_MRR: {
					console.log("ON_START_FETCH_MRR", action.payload)
					return {
						...state,
					}
				}
				case ON_FETCH_ARR: {
					console.log("ON_FETCH_ARR", action.payload)
					return {
						...state,
						ARRValue: action.payload.SummaBillingAvtal
					}
				}
				case ON_ERROR_FETCH_ARR: {
					console.log("ON_ERROR_FETCH_ARR", action.payload)
					return {
						...state,
					}
				}
				case ON_START_FETCH_ARR: {
					console.log("ON_START_FETCH_ARR", action.payload)
					return {
						...state,
					}
				}
				case ON_FETCH_ARPU: {
					console.log("ON_FETCH_ARPU", action.payload)
					return {
						...state,
						ARPUValue: action.payload.SummaBillingAvtal
					}
				}
				case ON_ERROR_FETCH_ARPU: {
					console.log("ON_ERROR_FETCH_ARPU", action.payload)
					return {
						...state,
					}
				}
				case ON_START_FETCH_ARPU: {
					console.log("ON_START_FETCH_ARPU", action.payload)
					return {
						...state,
					}
				}
        
        case ON_FETCH_SUMMA_ABONNEMANG_AVTAL: {
          console.log("ON_FETCH_SUMMA_ABONNEMANG_AVTAL", action.payload)
          return {
            ...state,
            SummaAbonnAvtal: action.payload.SummaAbonnAvtal,
          }
        }
        case ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL: {
          console.log("ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL", action.payload)
          return {
            ...state
          }
        }
        case ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL: {
          console.log("ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL", action.payload)
          return {
            ...state
          }
        }

        case ON_START_FETCH_VUNNEN_MONTH:{
            console.log("ON_START_FETCH_VUNNEN_MONTH",action)
            return {
                ...state,
                nextReq:false
            }
        }
        case ON_FETCH_VUNNEN_MONTH:{
            console.log("ON_FETCH_VUNNEN_MONTH",action)
            return {
                ...state,
                VunnenMonth:action.payload.VunnenMonth,
                nextReq:true
            }
        }
        case ON_ERROR_FETCH_VUNNEN_MONTH:{
            console.log("ON_ERROR_FETCH_VUNNEN_MONTH",action)
            return {
                ...state,
                nextReq:true
            }
        }
        case ON_START_FETCH_ABO_VUNNEN_MONTH:{
            console.log("ON_START_FETCH_ABO_VUNNEN_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_ABO_VUNNEN_MONTH:{
            console.log("ON_FETCH_ABO_VUNNEN_MONTH",action)
            return {
                ...state,
                AbonnemangVarde:action.payload.AbonnemangVarde
            }
        }
        case ON_ERROR_FETCH_ABO_VUNNEN_MONTH:{
            console.log("ON_ERROR_FETCH_ABO_VUNNEN_MONTH",action)
            return {
                ...state
            }
        }

        case ON_START_FETCH_ABON_VUNNEN_MONTH: {
          console.log("ON_START_FETCH_ABON_VUNNEN_MONTH", action.payload)
          return {
            ...state,
          }
        }
        case ON_FETCH_ABON_VUNNEN_MONTH: {
          console.log("ON_FETCH_ABON_VUNNEN_MONTH", action.payload)
          return {
            ...state,
            AbonnemangVardeN: action.payload.AbonnemangVarde
          }
        }
        case ON_ERROR_FETCH_ABON_VUNNEN_MONTH: {
          console.log("ON_ERROR_FETCH_ABON_VUNNEN_MONTH", action.payload)
          return {
            ...state,
          }
        }

        //ON_START_FETCH_ORDER_VUNNEN_MONTH,  ON_FETCH_ORDER_VUNNEN_MONTH, ON_ERROR_FETCH_ORDER_VUNNEN_MONTH,
        case ON_START_FETCH_ORDER_VUNNEN_MONTH:{
            console.log("ON_START_FETCH_ORDER_VUNNEN_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_ORDER_VUNNEN_MONTH:{
            console.log("ON_FETCH_ORDER_VUNNEN_MONTH",action)
            return {
                ...state,
                OrderVarde:action.payload.OrderVarde,
                OrdervardeBudget:action.payload.OrdervardeBudget,
            }
        }
        case ON_ERROR_FETCH_ORDER_VUNNEN_MONTH:{
            console.log("ON_ERROR_FETCH_ORDER_VUNNEN_MONTH",action)
            return {
                ...state
            }
        }
        //OrderVarde
        case ON_START_FETCH_AVSLUTA_AFFAR:{
            console.log("ON_START_FETCH_AVSLUTA_AFFAR",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVSLUTA_AFFAR:{
            console.log("ON_FETCH_AVSLUTA_AFFAR",action)
            return {
                ...state,
                AvslutaAffar:action.payload.AvslutaAffar
            }
        }
        case ON_ERROR_FETCH_AVSLUTA_AFFAR:{
            console.log("ON_ERROR_FETCH_AVSLUTA_AFFAR",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_DASHORDER_LIST:{
            console.log("ON_START_FETCH_DASHORDER_LIST",action)
            return {
                ...state
            }
        }
        case ON_FETCH_DASHORDER_LIST:{
            console.log("ON_FETCH_DASHORDER_LIST",action)
            return {
                ...state,
                DashOrderList:action.payload.OrderList
            }
        }
        case ON_ERROR_FETCH_DASHORDER_LIST:{
            console.log("ON_ERROR_FETCH_DASHORDER_LIST",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_MOTE_MONTH:{
            console.log("ON_START_FETCH_MOTE_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_MOTE_MONTH:{
            console.log("ON_FETCH_MOTE_MONTH",action)
            return {
                ...state,
                BokadMote:action.payload.BokadMote,
                UserMoteBudget:action.payload.UserMoteBudget
            }
        }
        case ON_ERROR_FETCH_MOTE_MONTH:{
            console.log("ON_ERROR_FETCH_MOTE_MONTH",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_AKTIVITITER_CHART:{
            console.log("ON_START_FETCH_AKTIVITITER_CHART",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AKTIVITITER_CHART:{
            console.log("ON_FETCH_AKTIVITITER_CHART",action)
            return {
                ...state,
                AktiviterArr:action.payload.AktiviterArr
            }
        }
        case ON_ERROR_FETCH_AKTIVITITER_CHART:{
            console.log("ON_ERROR_FETCH_AKTIVITITER_CHART",action)
            return {
                ...state
            }
        }
        //    ,,,
        case ON_START_FETCH_DASHBOARD_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_FILTER",action)
            return {
                ...state,
                currentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_FILTER:{
            console.log("ON_FETCH_DASHBOARD_FILTER",action)
            return {
                ...state,
                currentuser:action.payload.currentuser
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_FILTER",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER,
        case ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER",action)
            return {
                ...state,
               Prospektcurrentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_PROSPEKT_FILTER:{
            console.log("ON_FETCH_DASHBOARD_PROSPEKT_FILTER",action)
            return {
                ...state,
                Prospektcurrentuser:action.payload.currentuser
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_DASHBOARD_KONTOR_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_KONTOR_FILTER",action)
            return {
                ...state,
                Kontocurrentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_KONTOR_FILTER:{
            console.log("ON_FETCH_DASHBOARD_KONTOR_FILTER",action)
            return {
                ...state,
                Kontocurrentuser:action.payload.currentuser
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_DASHBOARD_ORDER_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_ORDER_FILTER",action)
            return {
                ...state,
                Ordercurrentuser:{}
            }
        }
        case ON_START_FETCH_DASHBOARD_SALJ_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_SALJ_FILTER",action)
            return {
                ...state,
                saljcurrentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_SALJ_FILTER:{
            console.log("ON_FETCH_DASHBOARD_SALJ_FILTER",action)
            return {
                ...state,
                saljcurrentuser:action.payload.currentuser
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_DASHBOARD_DIALER_FILTER, ON_FETCH_DASHBOARD_DIALER_FILTER, ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER,
        case ON_START_FETCH_DASHBOARD_DIALER_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_DIALER_FILTER",action)
            return {
                ...state
            }
        }
        case ON_FETCH_DASHBOARD_DIALER_FILTER:{
            console.log("ON_FETCH_DASHBOARD_DIALER_FILTER",action)
            return {
                ...state
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_DASHBOARD_BOKA_FILTER,ON_FETCH_DASHBOARD_BOKA_FILTER,ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER
        case ON_START_FETCH_DASHBOARD_BOKA_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_BOKA_FILTER",action)
            return {
                ...state,
                Bokacurrentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_BARN_FILTER:{
            console.log("ON_FETCH_DASHBOARD_BARN_FILTER",action)
            return {
                ...state                
            }
        }
        case ON_START_FETCH_DASHBOARD_ORDER_FILTER:{
            console.log("ON_START_FETCH_DASHBOARD_ORDER_FILTER",action)
            return {
                ...state,
                Ordercurrentuser:{}
            }
        }
        case ON_FETCH_DASHBOARD_ORDER_FILTER:{
            console.log("ON_FETCH_DASHBOARD_ORDER_FILTER",action)
            return {
                ...state,
                Ordercurrentuser:action.payload.currentuser
            }
        }
        case ON_FETCH_DASHBOARD_BOKA_FILTER:{
            console.log("ON_FETCH_DASHBOARD_BOKA_FILTER",action)
            return {
                ...state,
                Bokacurrentuser:action.payload.currentuser
            }
        }
        case ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER:{
            console.log("ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_BESTLIST_DIALER_BYAFID:{
            console.log("ON_START_FETCH_BESTLIST_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BESTLIST_DIALER_BYAFID:{
            console.log("ON_FETCH_BESTLIST_DIALER_BYAFID",action)
            return {
                ...state,
                BestListDialer:action.payload.BestListDialer
            }
        }
        case ON_ERROR_BESTLIST_DIALER_BYAFID:{
            console.log("ON_ERROR_BESTLIST_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID:{
            console.log("ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID:{
            console.log("ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID",action)
            return {
                ...state,
                AktiverKunder:action.payload.AktiverKunder
            }
        }
        case ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID:{
            console.log("ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //    ,,,
        case ON_START_FETCH_BOKAMOTE_DIALER_BYAFID:{
            console.log("ON_START_FETCH_BOKAMOTE_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BOKAMOTE_DIALER_BYAFID:{
            console.log("ON_FETCH_BOKAMOTE_DIALER_BYAFID",action)
            return {
                ...state,
                BokadMote:action.payload.BokadMote
            }
        }
        case ON_ERROR_BOKAMOTE_DIALER_BYAFID:{
            console.log("ON_ERROR_BOKAMOTE_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_SALTABLE_DIALER_BYAFID:{
            console.log("ON_START_FETCH_SALTABLE_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_SALTABLE_DIALER_BYAFID:{
            console.log("ON_FETCH_SALTABLE_DIALER_BYAFID",action)
            return {
                ...state,
                SalTabel:action.payload.SalTabel
            }
        }
        case ON_ERROR_SALTABLE_DIALER_BYAFID:{
            console.log("ON_ERROR_SALTABLE_DIALER_BYAFID",action)
            return {
                ...state
            }
        }

        //Lynes
        case ON_START_FETCH_LYNES_SAMTAL_BYAFID:{
            console.log("ON_START_FETCH_LYNES_SAMTAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_LYNES_SAMTAL_BYAFID:{
            console.log("ON_FETCH_LYNES_SAMTAL_BYAFID",action)
            return {
                ...state,
                LynesSamtalTable:action.payload.SalTabel
            }
        }
        case ON_ERROR_LYNES_SAMTAL_BYAFID:{
            console.log("ON_ERROR_LYNES_SAMTAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID:{
            console.log("ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID",action)
            return {
                ...state,
                LynesSamtalAntal:action.payload.LynesSamtalAntal
            }
        }
        case ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID:{
            console.log("ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID:{
            console.log("ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID:{
            console.log("ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID",action)
            return {
                ...state,
                LynesAvgDurLength:action.payload.LynesAvgDurLength
            }
        }
        case ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID:{
            console.log("ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID",action)
            return {
                ...state
            }
        }
        
    
        case ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID: {
          return {
            ...state
          }
        } 
        case ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID: {
          return {
            ...state,
            LynesLastSamtalTable:action.payload.LynesLastSamtalTable
          }
        } 
        case ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID: {
          return {
            ...state
          }
        }

        case ON_START_FETCH_LYNES_SAMTAL_GRAPH_BYAFID: {
          return {
            ...state
          }
        } 
        case ON_FETCH_LYNES_SAMTAL_GRAPH_BYAFID: {
          return {
            ...state,
            LynesLastSamtalGraph:action.payload.LynesLastSamtalGraph
          }
        } 
        case ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID: {
          return {
            ...state
          }
        }
        //,,,
        case ON_START_FETCH_AVSLUT_DIALER_BYAFID:{
            console.log("ON_START_FETCH_AVSLUT_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVSLUT_DIALER_BYAFID:{
            console.log("ON_FETCH_AVSLUT_DIALER_BYAFID",action)
            return {
                ...state,
                Hitrate:action.payload.Hitrate
            }
        }
        case ON_ERROR_AVSLUT_DIALER_BYAFID:{
            console.log("ON_ERROR_AVSLUT_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_STATUS_DIALER_BYAFID:{
            console.log("ON_START_FETCH_STATUS_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_STATUS_DIALER_BYAFID:{
            console.log("ON_FETCH_STATUS_DIALER_BYAFID",action)
            return {
                ...state,
                StatusTabel:action.payload.StatusTabel
            }
        }
        case ON_ERROR_STATUS_DIALER_BYAFID:{
            console.log("ON_ERROR_STATUS_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_AKTIVITED_DIALER_BYAFID:{
            console.log("ON_START_FETCH_AKTIVITED_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AKTIVITED_DIALER_BYAFID:{
            console.log("ON_FETCH_AKTIVITED_DIALER_BYAFID",action)
            return {
                ...state,
                AktiviterDailer:action.payload.AktiviterDailer
            }
        }
        case ON_ERROR_AKTIVITED_DIALER_BYAFID:{
            console.log("ON_ERROR_AKTIVITED_DIALER_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_TOPLIST_SAL_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_SAL_BYAFID:{
            console.log("ON_FETCH_TOPLIST_SAL_BYAFID",action)
            return {
                ...state,
                TopListSal:action.payload.TopListSal
            }
        }
        case ON_ERROR_TOPLIST_SAL_BYAFID:{
            console.log("ON_ERROR_TOPLIST_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_TOPLIST_SALANTAL_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_SALANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_SALANTAL_BYAFID:{
            console.log("ON_FETCH_TOPLIST_SALANTAL_BYAFID",action)
            return {
                ...state,
                TopListSalAntal:action.payload.TopListSalAntal
            }
        }
        case ON_ERROR_TOPLIST_SALANTAL_BYAFID:{
            console.log("ON_ERROR_TOPLIST_SALANTAL_BYAFID",action)
            return {
                ...state
            }
        }
       //,,,
       case ON_START_FETCH_AFFAR_SALANTAL_BYAFID:{
        console.log("ON_START_FETCH_AFFAR_SALANTAL_BYAFID",action)
        return {
            ...state
        }
    }
    case ON_FETCH_AFFAR_SALANTAL_BYAFID:{
        console.log("ON_FETCH_AFFAR_SALANTAL_BYAFID",action)
        return {
            ...state,
            VunnAffarAntalSal:action.payload.VunnAffarAntalSal,
            SenasteVunnen:action.payload.SenasteVunnen,
        }
    }
    case ON_ERROR_AFFAR_SALANTAL_BYAFID:{
        console.log("ON_ERROR_AFFAR_SALANTAL_BYAFID",action)
        return {
            ...state
        }
    }
        //,,,
        case ON_START_FETCH_AFFAR_SAL_BYAFID:{
            console.log("ON_START_FETCH_AFFAR_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AFFAR_SAL_BYAFID:{
            console.log("ON_FETCH_AFFAR_SAL_BYAFID",action)
            return {
                ...state,
                VunnAffarSal:action.payload.VunnAffarSal,
                VunnAffarSal2:action.payload.VunnAffarSal2,
                SenasteVunnenV:action.payload.SenasteVunnen,
            }
        }
        case ON_ERROR_AFFAR_SAL_BYAFID:{
            console.log("ON_ERROR_AFFAR_SAL_BYAFID",action)
            return {
                ...state
            }
        }


        // ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID,
        case ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID:{
            console.log("ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID:{
            console.log("ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID",action)
            return {
                ...state,
                VunnAffarSalProb:action.payload.VunnAffarSalProb,
                SenasteVunnenVProb:action.payload.SenasteVunnenProb,
                VunnAffarSalProbBudget:action.payload.VunnAffarSalProbBudget,
            }
        }
        case ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID:{
            console.log("ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        
        // ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_SAL_BYAFID,
        case ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID:{
            console.log("ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVTAL_VALUE_SAL_BYAFID:{
            console.log("ON_FETCH_AVTAL_VALUE_SAL_BYAFID",action)
            return {
                ...state,
                VunnAffarSalAvtal:action.payload.VunnAffarSalProb,
                SenasteVunnenVAvtal:action.payload.SenasteVunnenProb,
                VunnAffarSalAvtalBudget:action.payload.VunnAffarSalProbBudget,
            }
        }
        case ON_ERROR_AVTAL_VALUE_SAL_BYAFID:{
            console.log("ON_ERROR_AVTAL_VALUE_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        
        case ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID:{
            console.log("ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID:{
            console.log("ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID",action)
            return {
                ...state,
                VunnAffarSalAvtalBilling:action.payload.VunnAffarSalProb,
            }
        }
        case ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID:{
            console.log("ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        
    // ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,
        case ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID:{
            console.log("ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID:{
            console.log("ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID",action)
            return {
                ...state,
                VunnAvtalBillingYear:action.payload.VunnAvtalBillingYear,
            }
        }
        case ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID:{
            console.log("ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID",action)
            return {
                ...state
            }
        }


        //,,,
        case ON_START_FETCH_TOPLIST_BOK_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_BOK_BYAFID:{
            console.log("ON_FETCH_TOPLIST_BOK_BYAFID",action)
            return {
                ...state,
                TopListBokning:action.payload.TopListBokning
            }
        }
        case ON_ERROR_TOPLIST_BOK_BYAFID:{
            console.log("ON_ERROR_TOPLIST_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID:{
            console.log("ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID",action)
            return {
                ...state,
                [action.payload.tagStateKey]:action.payload.TopListSalAntal
            }
        }
        case ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID:{
            console.log("ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID:{
            console.log("ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID",action)
            return {
                ...state,
                TopListBokAntal:action.payload.TopListBokAntal
            }
        }
        case ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID:{
            console.log("ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state,
                BokadeMotenBokadTill:action.payload.BokadeMotenBokadTill
            }
        }
        case ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID,
        case ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state,
                AvBokadeMotenBokadAv:action.payload.AvBokadeMotenBokadAv
            }
        }
        case ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID,
        case ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state,
                AvBokadeMotenBokadTill:action.payload.AvBokadeMotenBokadTill
            }
        }
        case ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID:{
            console.log("ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID,
        case ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state,
                BokadeMotenBokadAv:action.payload.BokadeMotenBokadAv
            }
        }
        case ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID:{
            console.log("ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G:{
            console.log("ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G:{
            console.log("ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G",action)
            return {
                ...state,
                TopListBokAntalG:action.payload.TopListBokAntal
            }
        }
        case ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G:{
            console.log("ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B:{
            console.log("ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B:{
            console.log("ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B",action)
            return {
                ...state,
                TopListBokAntalB:action.payload.TopListBokAntal
            }
        }
        case ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B:{
            console.log("ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_ANTAL_BOK_BYAFID:{
            console.log("ON_START_FETCH_ANTAL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_ANTAL_BOK_BYAFID:{
            console.log("ON_FETCH_ANTAL_BOK_BYAFID",action)
            return {
                ...state,
                BokmoteAntalSal:action.payload.BokmoteAntalSal,
                BokmoteAntalSalBack:action.payload.BokmoteAntalSalBack,
                BokmoteAntalSalFram:action.payload.BokmoteAntalSalFram,
                SenasteBokmote:action.payload.SenasteBokmote,
            }
        }
        case ON_ERROR_ANTAL_BOK_BYAFID:{
            console.log("ON_ERROR_ANTAL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_TABEL_BOK_BYAFID:{
            console.log("ON_START_FETCH_TABEL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TABEL_BOK_BYAFID:{
            console.log("ON_FETCH_TABEL_BOK_BYAFID",action)
            return {
                ...state,
                BokningTable:action.payload.BokningTable
            }
        }
        case ON_ERROR_TABEL_BOK_BYAFID:{
            console.log("ON_ERROR_TABEL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_UTFALL_BOK_BYAFID:{
            console.log("ON_START_FETCH_UTFALL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALL_BOK_BYAFID:{
            console.log("ON_FETCH_UTFALL_BOK_BYAFID",action)
            return {
                ...state,
                Utfalldiagram:action.payload.Utfalldiagram
            }
        }
        case ON_ERROR_UTFALL_BOK_BYAFID:{
            console.log("ON_ERROR_UTFALL_BOK_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_ERROR_UTFALL_BOK_BUDGET_BYAFID,
        case ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID:{
            console.log("ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALL_BOK_BUDGET_BYAFID:{
            console.log("ON_FETCH_UTFALL_BOK_BUDGET_BYAFID",action)
            return {
                ...state,
                UtfallBMdiagram:action.payload.UtfallBMdiagram
            }
        }
        case ON_ERROR_UTFALL_BOK_BUDGET_BYAFID:{
            console.log("ON_ERROR_UTFALL_BOK_BUDGET_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_MONTH_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_MONTH_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_MONTH_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_MONTH_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                MonthVunneProspekt:action.payload.MonthVunneProspekt
            }
        }
        case ON_ERROR_MONTH_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_MONTH_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_ERROR_KVARTAL_PROSPEKTD_BYAFID,
        case ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_KVARTAL_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_KVARTAL_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                KvartalVunneProspekt:action.payload.KvartalVunneProspekt
            }
        }
        case ON_ERROR_KVARTAL_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_KVARTAL_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                AvslutaAffarList:action.payload.AvslutaAffarList
            }
        }
        case ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                VunnenListP:action.payload.VunnenListP
            }
        }
        case ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_PIPELINE_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_PIPELINE_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                ProspektPipeline:action.payload.ProspektPipeline
            }
        }
        case ON_ERROR_PIPELINE_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_PIPELINE_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //,,,
        case ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALL_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_UTFALL_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                utFallPros:action.payload.utFallPros
            }
        }
        case ON_ERROR_UTFALL_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_UTFALL_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }

        case ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID: {
          console.log("ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID", action.payload)
          return {
            ...state
          }
        }
        case ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID: {
          console.log("ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID", action.payload)
          return {
            ...state,
            utFallProsProb:action.payload.utFallProsProb
          }
        }
        case ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID: {
          console.log("ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID", action.payload)
          return {
            ...state
          }
        }
        
// ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_ERROR_AVTAL_VALUE_YEAR_BYAFID,
        case ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID: {
          console.log("ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID", action.payload)
          return {
            ...state
          }
        }
        case ON_FETCH_AVTAL_VALUE_YEAR_BYAFID: {
          console.log("ON_FETCH_AVTAL_VALUE_YEAR_BYAFID", action.payload)
          return {
            ...state,
            AvtalVardeYear:action.payload.utFallProsProb
          }
        }
        case ON_ERROR_AVTAL_VALUE_YEAR_BYAFID: {
          console.log("ON_ERROR_AVTAL_VALUE_YEAR_BYAFID", action.payload)
          return {
            ...state
          }
        }
        
        // ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID,

        
        case ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID: {
          console.log("ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID", action.payload)
          return {
            ...state,
          }
        }
        case ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID: {
          console.log("ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID", action.payload)
          return {
            ...state,
            TopListSalProb: action.payload.TopListSalProb
          }
        }
        case ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID: {
          console.log("ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID", action.payload)
          return {
            ...state,
          }
        }


        case ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID: {
          console.log("ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID", action.payload)
          return {
            ...state
          }
        }
        case ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID: {
          console.log("ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID", action.payload)
          return {
            ...state,
            utFallProsAntal:action.payload.utFallProsAntal
          }
        }
        case ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID: {
          console.log("ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID", action.payload)
          return {
            ...state
          }
        }
        //,,,
        case ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID:{
            console.log("ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLS_PROSPEKTD_BYAFID:{
            console.log("ON_FETCH_UTFALLS_PROSPEKTD_BYAFID",action)
            return {
                ...state,
                UtfallSdiagram:action.payload.UtfallSdiagram
            }
        }
        case ON_ERROR_UTFALLS_PROSPEKTD_BYAFID:{
            console.log("ON_ERROR_UTFALLS_PROSPEKTD_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_KLARA_AKTIVITET_MONTH:{
            console.log("ON_START_FETCH_KLARA_AKTIVITET_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_KLARA_AKTIVITET_MONTH:{
            console.log("ON_FETCH_KLARA_AKTIVITET_MONTH",action)
            return {
                ...state,
                KlaraAkt:action.payload.KlaraAkt
            }
        }
        case ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH:{
            console.log("ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_AVTALINVOICING_TABLE_ABONN, ON_FETCH_AVTALINVOICING_TABLE_ABONN, ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN,
        case ON_START_FETCH_AVTALINVOICING_TABLE_ABONN:{
            console.log("ON_START_FETCH_AVTALINVOICING_TABLE_ABONN",action)
            return {
                ...state
              }
          }
          case ON_FETCH_AVTALINVOICING_TABLE_ABONN:{
              console.log("ON_FETCH_AVTALINVOICING_TABLE_ABONN",action)
              return {
                  ...state,
                  AAVBINTableMonthly:action.payload.AAVBINTableMonthly
              }
          }
          case ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN:{
              console.log("ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN",action)
              return {
                  ...state
              }
          }
        // ON_START_FETCH_AVTAL_TABLE_ALL,ON_FETCH_AVTAL_TABLE_ALL,ON_ERROR_FETCH_AVTAL_TABLE_ALL,
        case ON_START_FETCH_AVTAL_TABLE_ALL:{
            console.log("ON_START_FETCH_AVTAL_TABLE_ABONN",action)
            return {
                ...state
              }
          }
          case ON_FETCH_AVTAL_TABLE_ALL:{
            console.log("ON_START_FETCH_AVTAL_TABLE_ABONN",action)
            return {
                ...state
              }
          }
          case ON_ERROR_FETCH_AVTAL_TABLE_ALL:{
            console.log("ON_START_FETCH_AVTAL_TABLE_ABONN",action)
            return {
                ...state
              }
          }
        // ON_START_FETCH_AKTIVA_AVTAL,ON_FETCH_AKTIVA_AVTAL,ON_ERROR_FETCH_AKTIVA_AVTAL,
        case ON_START_FETCH_AVTAL_TABLE_ABONN:{
          console.log("ON_START_FETCH_AVTAL_TABLE_ABONN",action)
          return {
              ...state
            }
        }
        case ON_FETCH_AVTAL_TABLE_ABONN:{
            console.log("ON_FETCH_AVTAL_TABLE_ABONN",action)
            return {
                ...state,
                AAVBTableMonthly:action.payload.AAVBTableMonthly
            }
        }
        case ON_ERROR_FETCH_AVTAL_TABLE_ABONN:{
            console.log("ON_ERROR_FETCH_AVTAL_TABLE_ABONN",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_AVTAL_TABLE_ENGÅNG:{
          console.log("ON_START_FETCH_AVTAL_TABLE_ENGÅNG",action)
          return {
              ...state
            }
        }
        case ON_FETCH_AVTAL_TABLE_ENGÅNG:{
            console.log("ON_FETCH_AVTAL_TABLE_ENGÅNG",action)
            return {
                ...state,
                AAVBTableEngang:action.payload.AAVBTableEngang
            }
        }
        case ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG:{
            console.log("ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG",action)
            return {
                ...state
            }
        }
        
        case ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING: {
          console.log("ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING")
          return  {
            ...state,
          }
        } 
        case ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING: {
          console.log("ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING")
          return  {
            ...state,
            AAVGraphRemaining: action.payload.AAVGraphRemaining,
          }
        } 
        case ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING: {
          console.log("ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING")
          return  {
            ...state,
          }
        } 

        case ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING: {
          console.log("ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING")
          return  {
            ...state,
          }
        } 
        case ON_FETCH_AVTAL_SUM_VALUE_REMAINING: {
          console.log("ON_FETCH_AVTAL_SUM_VALUE_REMAINING")
          return  {
            ...state,
            AAVSumRemaining: action.payload.AAVSumRemaining,
          }
        } 
        case ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING: {
          console.log("ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING")
          return  {
            ...state,
          }
        } 


        case ON_START_FETCH_AKTIVA_AVTAL:{
          console.log("ON_START_FETCH_AKTIVA_AVTAL",action)
          return {
              ...state
            }
        }
        case ON_FETCH_AKTIVA_AVTAL:{
            console.log("ON_FETCH_AKTIVA_AVTAL",action)
            return {
                ...state,
                AkAvtal:action.payload.AkAvtal
            }
        }
        case ON_ERROR_FETCH_AKTIVA_AVTAL:{
            console.log("ON_ERROR_FETCH_AKTIVA_AVTAL",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_SKAPAD_PROSPEKT_MONTH:{
            console.log("ON_START_FETCH_SKAPAD_PROSPEKT_MONTH",action)
            return {
                ...state
            }
        }   
        case ON_FETCH_SKAPAD_PROSPEKT_MONTH:{
            console.log("ON_FETCH_SKAPAD_PROSPEKT_MONTH",action)
            return {
                ...state,
                SkProspekt:action.payload.SkProspekt
            }
        }
        case ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH:{
            console.log("ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_SUMMA_OFFERT_MONTH:{
            console.log("ON_START_FETCH_SUMMA_OFFERT_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_SUMMA_OFFERT_MONTH:{
            console.log("ON_FETCH_SUMMA_OFFERT_MONTH",action)
            return {
                ...state,
                SummaOffert:action.payload.SummaOffert
            }
        }
        case ON_ERROR_FETCH_SUMMA_OFFERT_MONTH:{
            console.log("ON_ERROR_FETCH_SUMMA_OFFERT_MONTH",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_GENOM_MOTE, ON_FETCH_GENOM_MOTE, ON_ERROR_FETCH_GENOM_MOTE,
        case ON_START_FETCH_GENOM_MOTE:{
            console.log("ON_START_FETCH_GENOM_MOTE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_GENOM_MOTE:{
            console.log("ON_FETCH_GENOM_MOTE",action)
            return {
                ...state,
                GnomMote:action.payload.GnomMote
            }
        }
        case ON_ERROR_FETCH_GENOM_MOTE:{
            console.log("ON_ERROR_FETCH_GENOM_MOTE",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_AVBOKA_MOTE, ON_FETCH_AVBOKA_MOTE, ON_ERROR_FETCH_AVBOKA_MOTE,
        case ON_START_FETCH_AVBOKA_MOTE:{
            console.log("ON_START_FETCH_AVBOKA_MOTE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_AVBOKA_MOTE:{
            console.log("ON_FETCH_AVBOKA_MOTE",action)
            return {
                ...state,
                AVbokaMote:action.payload.AVbokaMote
            }
        }
        case ON_ERROR_FETCH_AVBOKA_MOTE:{
            console.log("ON_ERROR_FETCH_AVBOKA_MOTE",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_BEFKUND_MOTE:{
            console.log("ON_START_FETCH_BEFKUND_MOTE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BEFKUND_MOTE:{
            console.log("ON_FETCH_BEFKUND_MOTE",action)
            return {
                ...state,
                BefMote:action.payload.BefMote
            }
        }
        case ON_ERROR_FETCH_BEFKUND_MOTE:{
            console.log("ON_ERROR_FETCH_BEFKUND_MOTE",action)
            return {
                ...state
            }
        }
        //ON_STRAT_FETCH_NYKUND_MOTE, ON_FETCH_NYKUND_MOTE, ON_ERROR_FETCH_NYKUND_MOTE,
        case ON_START_FETCH_NYKUND_MOTE:{
            console.log("ON_STRAT_FETCH_NYKUND_MOTE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_NYKUND_MOTE:{
            console.log("ON_FETCH_NYKUND_MOTE",action)
            return {
                ...state,
                NYMote:action.payload.NYMote
            }
        }
        case ON_ERROR_FETCH_NYKUND_MOTE:{
            console.log("ON_ERROR_FETCH_NYKUND_MOTE",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_NYUPPKUND_MOTE, ON_FETCH_NYUPPKUND_MOTE, ON_ERROR_FETCH_NYUPPKUND_MOTE,
        case ON_START_FETCH_NYUPPKUND_MOTE:{
            console.log("ON_START_FETCH_NYUPPKUND_MOTE",action)
            return {
                ...state
            }
        }
        case ON_FETCH_NYUPPKUND_MOTE:{
            console.log("ON_FETCH_NYUPPKUND_MOTE",action)
            return {
                ...state,
                NYUppMote:action.payload.NYUppMote
            }
        }
        case ON_ERROR_FETCH_NYUPPKUND_MOTE:{
            console.log("ON_ERROR_FETCH_NYUPPKUND_MOTE",action)
            return {
                ...state
            }
        }
        //, , ,    
        case ON_START_FETCH_TOPLIST_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_TOPLIST_KONTOR_BYAFID:{
            console.log("ON_FETCH_TOPLIST_KONTOR_BYAFID",action)
            return {
                ...state,
                TopListKon:action.payload.TopListKon
            }
        }
        case ON_ERROR_TOPLIST_KONTOR_BYAFID:{
            console.log("ON_ERROR_TOPLIST_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_LIST_KONTOR_BYAFID, ON_FETCH_LIST_KONTOR_BYAFID, ON_ERROR_LIST_KONTOR_BYAFID,
        case ON_START_FETCH_LIST_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_LIST_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_LIST_KONTOR_BYAFID:{
            console.log("ON_FETCH_LIST_KONTOR_BYAFID",action)
            return {
                ...state,
                TopListKontor:action.payload.TopListKontor
            }
        }
        case ON_ERROR_LIST_KONTOR_BYAFID:{
            console.log("ON_ERROR_LIST_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_UTFALLS_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLS_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLS_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLS_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramKontor:action.payload.UtfallSdiagramKontor
            }
        }
        case ON_ERROR_UTFALLS_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLS_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLSPRO_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLSPRO_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramProsKontor:action.payload.UtfallSdiagramProsKontor
            }
        }
        case ON_ERROR_UTFALLSPRO_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLSPRO_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLSORD_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLSORD_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramOrderKontor:action.payload.UtfallSdiagramOrderKontor
            }
        }
        case ON_ERROR_UTFALLSORD_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLSORD_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramKlarAkt:action.payload.UtfallSdiagramKlarAkt
            }
        }
        case ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramNOffertKontor:action.payload.UtfallSdiagramNOffertKontor
            }
        }
        case ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID,
        case ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID:{
            console.log("ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramBmoteKontor:action.payload.UtfallSdiagramBmoteKontor
            }
        }
        case ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID:{
            console.log("ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_LASTVUNNEN_KONTOR_BYAFID:{
            console.log("ON_FETCH_LASTVUNNEN_KONTOR_BYAFID",action)
            return {
                ...state,
                LastVunnenKontor:action.payload.LastVunnenKontor
            }
        }
        case ON_ERROR_LASTVUNNEN_KONTOR_BYAFID:{
            console.log("ON_ERROR_LASTVUNNEN_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_BOKADE_KONTOR_BYAFID:{
            console.log("ON_START_FETCH_BOKADE_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        case ON_FETCH_BOKADE_KONTOR_BYAFID:{
            console.log("ON_FETCH_BOKADE_KONTOR_BYAFID",action)
            return {
                ...state,
                LastBokadeKontor:action.payload.LastBokadeKontor
            }
        }
        case ON_ERROR_BOKADE_KONTOR_BYAFID:{
            console.log("ON_ERROR_BOKADE_KONTOR_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_COUNT_OFFERT_MONTH:{
            console.log("ON_START_FETCH_COUNT_OFFERT_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_COUNT_OFFERT_MONTH:{
            console.log("ON_FETCH_COUNT_OFFERT_MONTH",action)
            return {
                ...state,
                CountOffert:action.payload.CountOffert
            }
        }
        case ON_ERROR_FETCH_COUNT_OFFERT_MONTH:{
            console.log("ON_ERROR_FETCH_COUNT_OFFERT_MONTH",action)
            return {
                ...state
            }
        }



        case ON_START_FETCH_COUNT_ARENDE_NY_MONTH:{
            console.log("ON_START_FETCH_COUNT_ARENDE_NY_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_COUNT_ARENDE_NY_MONTH:{
            console.log("ON_FETCH_COUNT_ARENDE_NY_MONTH",action)
            return {
                ...state,
                CountArendenNya:action.payload.CountArenden
            }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH:{
            console.log("ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH:{
            console.log("ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_COUNT_ARENDE_KLARA_MONTH:{
            console.log("ON_FETCH_COUNT_ARENDE_KLARA_MONTH",action)
            return {
                ...state,
                CountArendenKlara:action.payload.CountArenden
            }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH:{
            console.log("ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH",action)
            return {
                ...state
            }
        }
        
        case ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH:{
            console.log("ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH",action)
            return {
                ...state
            }
        }
        case ON_FETCH_COUNT_ARENDE_OPPNA_MONTH:{
            console.log("ON_FETCH_COUNT_ARENDE_OPPNA_MONTH",action)
            return {
                ...state,
                CountArendenOppna:action.payload.CountArenden
            }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH:{
            console.log("ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST:{
          console.log("",action)
          return {
            ...state
          }
        }
        case ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST:{
          console.log("",action)
          return {
            ...state,
            ArendeTopOppnaList: action.payload.ArendeTopOppnaList
          }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST:{
          console.log("",action)
          return {
            ...state
          }
        }
        
        case ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER:{
          console.log("",action)
          return {
            ...state
          }
        }
        case ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER:{
          console.log("",action)
          return {
            ...state,
            ArendeOppnaPagaende: action.payload.ArendeOppnaPagaende
          }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER:{
          console.log("",action)
          return {
            ...state
          }
        }
        
        case ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR:{
          console.log("",action)
          return {
            ...state
          }
        }
        case ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR:{
          console.log("",action)
          return {
            ...state,
            ArendenNyaStangdaYear: action.payload.ArendenNyaStangdaYear
          }
        }
        case ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR:{
          console.log("",action)
          return {
            ...state
          }
        }


        case ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR:{
          console.log("",action)
          return {
            ...state
          }
        }
        case ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR:{
          console.log("",action)
          return {
            ...state,
            AvtalLoperUtOmForYear: action.payload.AvtalLoperUtOmForYear
          }
        }
        case ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR:{
          console.log("",action)
          return {
            ...state
          }
        }
        
        
        case ON_START_FETCH_COUNT_LAST_ARENDE:{
          console.log("",action)
          return {
            ...state
          }
        }
        case ON_FETCH_COUNT_LAST_ARENDE:{
          console.log("",action)
          return {
            ...state,
            LastArenden: action.payload.LastArenden
          }
        }
        case ON_ERROR_FETCH_COUNT_LAST_ARENDE:{
          console.log("",action)
          return {
            ...state
          }
        }

        

        case ON_START_FETCH_PROJECT_WORKLOAD:{
            console.log("ON_START_FETCH_PROJECT_WORKLOAD",action)
            return {
                ...state,
                // ProjectWorkload: []
            }
        }
        case ON_FETCH_PROJECT_WORKLOAD:{
            console.log("ON_FETCH_PROJECT_WORKLOAD",action)
            return {
                ...state,
                ProjectWorkload:action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_WORKLOAD:{
            console.log("ON_ERROR_FETCH_PROJECT_WORKLOAD",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED:{
            console.log("ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED",action)
            return {
                ...state,
                // ProjectCreatedVsCompleted:[]
            }
        }
        case ON_FETCH_PROJECT_CREATEDVSCOMPLETED:{
            console.log("ON_FETCH_PROJECT_CREATEDVSCOMPLETED",action)
            return {
                ...state,
                ProjectCreatedVsCompleted:action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED:{
            console.log("ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_PROJECT_TASKS:{
            console.log("ON_START_FETCH_PROJECT_TASKS",action)
            return {
                ...state,
                // ProjectTasks:[]
            }
        }
        case ON_FETCH_PROJECT_TASKS:{
            console.log("ON_FETCH_PROJECT_TASKS",action)
            return {
                ...state,
                ProjectTasks:action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_TASKS:{
            console.log("ON_ERROR_FETCH_PROJECT_TASKS",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_PROJECT_TIMESPENT:{
            console.log("ON_START_FETCH_PROJECT_TIMESPENT",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_PROJECT_TIMESPENT:{
            console.log("ON_FETCH_PROJECT_TIMESPENT",action)
            return {
                ...state,
                ProjectTimeSpent:action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_TIMESPENT:{
            console.log("ON_ERROR_FETCH_PROJECT_TIMESPENT",action)
            return {
                ...state
            }
        }

        case ON_START_FETCH_PROJECT_AHEAD_BEHIND:{
            console.log("ON_START_FETCH_PROJECT_AHEAD_BEHIND",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_PROJECT_AHEAD_BEHIND:{
            console.log("ON_FETCH_PROJECT_AHEAD_BEHIND",action)
            return {
                ...state,
                ProjectAheadBehind:action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND:{
            console.log("ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND",action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL:{
            console.log("ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL", action)
            return {
                ...state
            }
        } 
        case ON_FETCH_PROJECT_STATUS_LIST_ANTAL:{
            console.log("ON_FETCH_PROJECT_STATUS_LIST_ANTAL", action)
            return {
                ...state,
                ProjectStatusAntalList:action.payload
            }
        } 
        case ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL:{
            console.log("ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL", action)
            return {
                ...state
            }
        }
        case ON_START_FETCH_PROJECT_KLARA_KORT_TM: {
            console.log("ON_START_FETCH_PROJECT_KLARA_KORT_TM", action)
            return {
                ...state,
            }
        }
        case ON_FETCH_PROJECT_KLARA_KORT_TM: {
            console.log("ON_FETCH_PROJECT_KLARA_KORT_TM", action)
            return {
                ...state,
                AntalKortKlara: action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM: {
            console.log("ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM", action)
            return {
                ...state,
            }
        }
        case ON_START_FETCH_PROJECT_KORT_KVAR_TM: {
            console.log("ON_START_FETCH_PROJECT_KORT_KVAR_TM", action)
            return {
                ...state,
            }
        }
        case ON_FETCH_PROJECT_KORT_KVAR_TM: {
            console.log("ON_FETCH_PROJECT_KORT_KVAR_TM", action)
            return {
                ...state,
                AntalKortKvar: action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM: {
            console.log("ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM", action)
            return {
                ...state,
            }
        }

        case ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL: {
            console.log('ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL', action)
            return {
                ...state,
            }
        }
        case ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL: {
            console.log('ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL', action)
            return {
                ...state,
                ProjectDeadlineAntalList: action.payload
            }
        }
        case ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL: {
            console.log('ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL', action)
            return {
                ...state,
            }
        }

        //ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_ERROR_ORDERTYPE_ANTAL_BYAFID,
        case ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_ORDERTYPE_ANTAL_BYAFID:{
            console.log("ON_FETCH_ORDERTYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                OrderTypeAntal:action.payload.OrderTypeAntal
            }
        }
        case ON_ERROR_ORDERTYPE_ANTAL_BYAFID:{
            console.log("ON_ERROR_ORDERTYPE_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        // ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID,
        case ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID:{
            console.log("ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                ProspektTypeAntal:action.payload.ProspektTypeAntal
            }
        }
        case ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID:{
            console.log("ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        
      //  ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID ,ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID, ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID,
        case ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID:{
            console.log("ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID",action)
            return {
                ...state,
                AvtalTypeAntal:action.payload.AvtalTypeAntal
            }
        }
        case ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID:{
            console.log("ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        
    // ON_START_FETCH_AVTAL_GROWTH_BYAFID, ON_FETCH_AVTAL_GROWTH_BYAFID, ON_ERROR_AVTAL_GROWTH_BYAFID,
        case ON_START_FETCH_AVTAL_GROWTH_BYAFID:{
            console.log("ON_START_FETCH_AVTAL_GROWTH_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_AVTAL_GROWTH_BYAFID:{
            console.log("ON_FETCH_AVTAL_GROWTH_BYAFID",action)
            return {
                ...state,
                AvtalGrowth:action.payload.AvtalGrowth
            }
        }
        case ON_ERROR_AVTAL_GROWTH_BYAFID:{
            console.log("ON_ERROR_AVTAL_GROWTH_BYAFID",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_FETCH_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state,
                ArtiklarAntal:action.payload.ArtiklarAntal
            }
        }
        case ON_ERROR_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_ERROR_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_NY_ORDER_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_NY_ORDER_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_NY_ORDER_ANTAL_BYAFID:{
            console.log("ON_FETCH_NY_ORDER_ANTAL_BYAFID",action)
            return {
                ...state,
                AntalNyaOrder:action.payload.AntalNyaOrder
            }
        }
        case ON_ERROR_NY_ORDER_ANTAL_BYAFID:{
            console.log("ON_ERROR_NY_ORDER_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_STATUS_ORDER_ANTAL_BYAFID:{
            console.log("ON_FETCH_STATUS_ORDER_ANTAL_BYAFID",action)
            return {
                ...state,
                OrderStatusAntalList:action.payload.OrderStatusAntalList
            }
        }
        case ON_ERROR_STATUS_ORDER_ANTAL_BYAFID:{
            console.log("ON_ERROR_STATUS_ORDER_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        //, , ,
        case ON_START_FETCH_STATUS_HAS_ABONN:{
            console.log("ON_START_FETCH_STATUS_HAS_ABONN",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_STATUS_HAS_ABONN:{
            console.log("ON_FETCH_STATUS_HAS_ABONN",action)
            return {
                ...state,
                AfidHasAbon:action.payload.AfidHasAbon
            }
        }
        case ON_ERROR_STATUS_HAS_ABONN:{
            console.log("ON_ERROR_STATUS_HAS_ABONN",action)
            return {
                ...state
            }
        }
        //,,, 
        case ON_START_FETCH_STATUS_HAS_ORERV:{
            console.log("ON_START_FETCH_STATUS_HAS_ORERV",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_STATUS_HAS_ORERV:{
            console.log("ON_FETCH_STATUS_HAS_ORERV",action)
            return {
                ...state,
                AfidHasOrderVarde:action.payload.AfidHasOrderVarde
            }
        }
        case ON_ERROR_STATUS_HAS_ORERV:{
            console.log("ON_ERROR_STATUS_HAS_ORERV",action)
            return {
                ...state
            }
        }
        //
        case ON_START_FETCH_ORDER_VARDE_YEAR:{
            console.log("ON_START_FETCH_ORDER_VARDE_YEAR",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_ORDER_VARDE_YEAR:{
            console.log("ON_FETCH_ORDER_VARDE_YEAR",action)
            return {
                ...state,
                OrderVardeList:action.payload.OrderVardeList
            }
        }
        case ON_ERROR_ORDER_VARDE_YEAR:{
            console.log("ON_ERROR_ORDER_VARDE_YEAR",action)
            return {
                ...state
            }
        }
        //OrderVardeList
        //ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                TopListChildKon:action.payload.TopListChildKon
            }
        }
        case ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //TopListChildKon
        //
        case ON_START_FETCH_LIST_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_LIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_LIST_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_LIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                TopListKontorBarn:action.payload.TopListKontorBarn
            }
        }
        case ON_ERROR_LIST_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_LIST_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //TopListKontorBarn
        //ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramKontoChild:action.payload.UtfallSdiagramKontoChild
            }
        }
        case ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //UtfallSdiagramKontoChild
        //ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramBarnProsKontor:action.payload.UtfallSdiagramBarnProsKontor
            }
        }
        case ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //UtfallSdiagramBarnProsKontor
        //ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramBarnOrderKontor:action.payload.UtfallSdiagramBarnOrderKontor
            }
        }
        case ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //UtfallSdiagramBarnOrderKontor
        //ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                UtfallSdiagramBmoteBarnKontor:action.payload.UtfallSdiagramBmoteBarnKontor
            }
        }
        case ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //UtfallSdiagramBmoteBarnKontor
        //ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID,
        case ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                LastVunnenChildKontor:action.payload.LastVunnenChildKontor
            }
        }
        case ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }
        //LastVunnenChildKontor
        //
        case ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID:{
            console.log("ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_BOKADE_CHILD_KONTO_BYAFID:{
            console.log("ON_FETCH_BOKADE_CHILD_KONTO_BYAFID",action)
            return {
                ...state,
                LastBokadeChildKontor:action.payload.LastBokadeChildKontor
            }
        }
        case ON_ERROR_BOKADE_CHILD_KONTO_BYAFID:{
            console.log("ON_ERROR_BOKADE_CHILD_KONTO_BYAFID",action)
            return {
                ...state
            }
        }


        ///DASCHBOARDCUSTOM
        // CustomDashboardLoading: false,
        // CustomDashboardList: [],
        // currentCustomDashboard:{},
        case ON_START_GET_DASHBOARD_CUSTOM_LIST: {
          console.log("ON_START_GET_DASHBOARD_CUSTOM_LIST", action)
          return {
            ...state,
            //CustomDashboardList: [],
            CustomDashboardLoading: true,
          }
        }
        case ON_GET_DASHBOARD_CUSTOM_LIST: {
          console.log("ON_GET_DASHBOARD_CUSTOM_LIST", action)
          return {
            ...state,
            CustomDashboardList: action.payload.customDashboardList,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_GET_DASHBOARD_CUSTOM_LIST: {
          console.log("ON_ERROR_GET_DASHBOARD_CUSTOM_LIST", action)
          return {
            ...state,
            CustomDashboardList: [],
            CustomDashboardLoading: false,
          }
        }
        case ON_START_ADD_DASHBOARD_CUSTOM: {
          console.log("ON_START_ADD_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: {},
            CustomDashboardList: [],
            CustomDashboardLoading: true,
          }
        }
        case ON_ADD_DASHBOARD_CUSTOM: {
          console.log("ON_ADD_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: action.payload.currentCustomDashboard,
            CustomDashboardList: action.payload.customDashboardList,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_ADD_DASHBOARD_CUSTOM: {
          console.log("ON_ERROR_ADD_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: {},
            CustomDashboardList: [],
            CustomDashboardLoading: false,
          }
        }
        case ON_START_UPDATE_DASHBOARD_CUSTOM: {
          console.log("ON_START_UPDATE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardLoading: true,
            reloadData:false
          }
        }
        case ON_UPDATE_DASHBOARD_CUSTOM: {
          console.log("ON_UPDATE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: action.payload.customDashboardList,
            reloadData:!state.reloadData,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_UPDATE_DASHBOARD_CUSTOM: {
          console.log("ON_ERROR_UPDATE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardLoading: false,
          }
        }
        case ON_START_REMOVE_DASHBOARD_CUSTOM: {
          console.log("ON_START_REMOVE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: [],
            CustomDashboardLoading: true,
          }
        }
        case ON_REMOVE_DASHBOARD_CUSTOM: {
          console.log("ON_REMOVE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: action.payload,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_REMOVE_DASHBOARD_CUSTOM: {
          console.log("ON_ERROR_REMOVE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: [],
            CustomDashboardLoading: false,
          }
        }
        case ON_START_GET_DASHBOARD_CUSTOM: {
          console.log("ON_START_GET_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: {},
            CustomDashboardLoading: true,
          }
        }
        case ON_GET_DASHBOARD_CUSTOM: {
          console.log("ON_GET_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: action.payload.currentCustomDashboard,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_GET_DASHBOARD_CUSTOM: {
          console.log("ON_ERROR_GET_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            currentCustomDashboard: {},
            CustomDashboardLoading: false,
          }
        }
        case ON_START_DELETE_DASHBOARD_CUSTOM: {
          console.log("ON_START_DELETE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: [],
            CustomDashboardLoading: true,
          }
        }
        case ON_DELETE_DASHBOARD_CUSTOM: {
          console.log("ON_DELETE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: action.payload.customDashboardList,
            CustomDashboardLoading: false,
          }
        }
        case ON_ERROR_DELETE_DASHBOARD_CUSTOM: {
          console.log("ON_ERROR_DELETE_DASHBOARD_CUSTOM", action)
          return {
            ...state,
            CustomDashboardList: [],
            CustomDashboardLoading: false,
          }
        }


        //competition
        case ON_START_GET_DASHBOARD_COMPETITION_LIST: {
          console.log("ON_START_GET_DASHBOARD_CCOMPETITIONLIST", action)
          return {
            ...state,
           // DashboardCompetitionList: [],
            DashboardCompetitionLoading: true,
          }
        }
        case ON_GET_DASHBOARD_COMPETITION_LIST: {
          console.log("ON_GET_DASHBOARD_COMPETITION_LIST", action)
          return {
            ...state,
            DashboardCompetitionList: action.payload.DashboardCompetitionList,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_GET_DASHBOARD_COMPETITION_LIST: {
          console.log("ON_ERROR_GET_DASHBOARD_COMPETITION_LIST", action)
          return {
            ...state,
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: false,
          }
        }
        case ON_START_ADD_DASHBOARD_COMPETITION: {
          console.log("ON_START_ADD_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: {},
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: true,
          }
        }
        case ON_ADD_DASHBOARD_COMPETITION: {
          console.log("ON_ADD_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: action.payload.currentDashboardCompetition,
            DashboardCompetitionList: action.payload.DashboardCompetitionList,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_ADD_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_ADD_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: {},
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: false,
          }
        }
        case ON_START_UPDATE_DASHBOARD_COMPETITION: {
          console.log("ON_START_UPDATE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionLoading: true,
          }
        }
        case ON_UPDATE_DASHBOARD_COMPETITION: {
          console.log("ON_UPDATE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: action.payload.currentDashboardCompetition,
            DashboardCompetitionList: action.payload.DashboardCompetitionList,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_UPDATE_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_UPDATE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_START_REMOVE_DASHBOARD_COMPETITION: {
          console.log("ON_START_REMOVE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: true,
          }
        }
        case ON_REMOVE_DASHBOARD_COMPETITION: {
          console.log("ON_REMOVE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: action.payload,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_REMOVE_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_REMOVE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: false,
          }
        }
        case ON_START_GET_DASHBOARD_COMPETITION: {
          console.log("ON_START_GET_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: {},
            DashboardCompetitionLoading: true,
          }
        }
        case ON_GET_DASHBOARD_COMPETITION: {
          console.log("ON_GET_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: action.payload.currentDashboardCompetition,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_GET_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_GET_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            currentDashboardCompetition: {},
            DashboardCompetitionLoading: false,
          }
        }
        case ON_START_DELETE_DASHBOARD_COMPETITION: {
          console.log("ON_START_DELETE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: true,
          }
        }
        case ON_DELETE_DASHBOARD_COMPETITION: {
          console.log("ON_DELETE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: action.payload.DashboardCompetitionList,
            DashboardCompetitionLoading: false,
          }
        }
        case ON_ERROR_DELETE_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_DELETE_DASHBOARD_COMPETITION", action)
          return {
            ...state,
            DashboardCompetitionList: [],
            DashboardCompetitionLoading: false,
          }
        }
        case ON_POST_CHAT_DASHBOARD_COMPETITION: {
          console.log("ON_POST_CHAT_DASHBOARD_COMPETITION", action.payload) 
          return {
            ...state,
            currentDashboardCompetition: {...state.currentDashboardCompetition, messages: action.payload.messages}
          }
        }
        case ON_START_POST_CHAT_DASHBOARD_COMPETITION: {
          console.log("ON_START_POST_CHAT_DASHBOARD_COMPETITION", action.payload) 
          return {
            ...state,
          }
        }
        case ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION: {
          console.log("ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION", action.payload) 
          return {
            ...state,
          }
        }
        //LastBokadeChildKontor
        //ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID,
        case ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state,
                // ProjectTimeSpent:[]
            }
        }
        case ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state,
                TotaltOrderArtiklar:action.payload.TotaltOrderArtiklar
            }
        }
        case ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID:{
            console.log("ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID",action)
            return {
                ...state
            }
        }
        

        case ON_START_GET_DASHBOARD_TV_DEVICE_LIST: {
            console.log("ON_START_GET_DASHBOARD_TV_DEVICE_LIST", action.payload)
            return {
                ...state,
                dashboardTVDevices:[],
            }
        }
        case ON_GET_DASHBOARD_TV_DEVICE_LIST: {
            console.log("ON_GET_DASHBOARD_TV_DEVICE_LIST", action.payload)
            return {
                ...state,
                dashboardTVDevices:action.payload.dashboardTVDevices,
            }
        }
        case ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST: {
            console.log("ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST", action.payload)
            return {
                ...state,
                dashboardTVDevices:[],
            }
        }
        case ON_START_ADD_DASHBOARD_TV_DEVICE : {
            console.log("ON_START_ADD_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: true,
                DashboardDeviceErrorMsg: ""
            }
        }
        case ON_ADD_DASHBOARD_TV_DEVICE: {
            console.log("ON_ADD_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: false,
                dashboardTVDevices:action.payload.dashboardTVDevices,
                DashboardDeviceErrorMsg: ""
            }
        }
        case ON_ERROR_ADD_DASHBOARD_TV_DEVICE : {
            console.log("ON_ERROR_ADD_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                // dashboardTVDevices:[],
                DashboardDeviceLoading: false,
                DashboardDeviceErrorMsg: action.payload.err
            }
        }
        case ON_START_REMOVE_DASHBOARD_TV_DEVICE: {
            console.log("ON_START_REMOVE_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: true,
            }
        }
        case ON_REMOVE_DASHBOARD_TV_DEVICE: {
            console.log("ON_REMOVE_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: false,
                dashboardTVDevices:action.payload.dashboardTVDevices,
            }
        }
        case ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE: {
            console.log("ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                dashboardTVDevices:[],
                DashboardDeviceLoading: false,
            }
        }
        case ON_START_CONNECT_DASHBOARD_TV_DEVICE : {
            console.log("ON_START_CONNECT_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: true,
                DashboardDeviceErrorMsg: '',
            }
        }
        case ON_CONNECT_DASHBOARD_TV_DEVICE : {
            console.log("ON_CONNECT_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: false,
                DashboardDeviceErrorMsg: '',
            }
        }
        case ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE : {
            console.log("ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE", action.payload)
            return {
                ...state,
                DashboardDeviceLoading: false,
                DashboardDeviceErrorMsg: action.payload.err,
            }
        }
        case ON_START_INIT_DASHBOARD_TV_DEVICE: {
          console.log("ON_START_INIT_DASHBOARD_TV_DEVICE", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: true,
           // DashboardTVDeviceConnection: {}
          }
        }
        case ON_INIT_DASHBOARD_TV_DEVICE: {
          console.log("ON_INIT_DASHBOARD_TV_DEVICE", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            DashboardTVDeviceConnection: action.payload.connectionData
          }
        }
        case ON_ERROR_INIT_DASHBOARD_TV_DEVICE: {
          console.log("ON_ERROR_INIT_DASHBOARD_TV_DEVICE", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            // DashboardTVDeviceConnection: {},
          }
        }


        case ON_START_ADD_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_START_ADD_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: true,
          }
        }
        case ON_ADD_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_ADD_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            dashboardTVDevices:action.payload.dashboardTVDevices,
          }
        }
        case ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            dashboardTVDevices:[],
          }
        }
        case ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: true,
          }
        }
        case ON_REMOVE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_REMOVE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            dashboardTVDevices:action.payload.dashboardTVDevices,
            DashboardDeviceLoading: false,
          }
        }
        case ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            dashboardTVDevices:[],
          }
        }
        case ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: true,
          }
        }
        case ON_UPDATE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_UPDATE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            dashboardTVDevices:action.payload.dashboardTVDevices,
            DashboardDeviceLoading: false,
          }
        }
        case ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY: {
          console.log("ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY", action.payload)
          return {
            ...state,
            DashboardDeviceLoading: false,
            dashboardTVDevices:[],
          }
        }
        //ON_START_GET_LOBBY_CUSTOM, ON_GET_LOBBY_CUSTOM, ON_ERROR_GET_LOBBY_CUSTOM,
        case ON_START_GET_LOBBY_CUSTOM: {
            console.log("ON_START_GET_LOBBY_CUSTOM", action.payload)
            return {
              ...state
            }
          }
          case ON_GET_LOBBY_CUSTOM: {
            console.log("ON_GET_LOBBY_CUSTOM", action.payload)
            return {
              ...state,
              MyLobby:action.payload.MyLobby,
            }
          }
          case ON_ERROR_GET_LOBBY_CUSTOM: {
            console.log("ON_ERROR_GET_LOBBY_CUSTOM", action.payload)
            return {
              ...state,
            }
          }
        //ON_START_UPDATE_LOBBY_CUSTOM,ON_UPDATE_LOBBY_CUSTOM,ON_ERROR_UPDATE_LOBBY_CUSTOM,
        case ON_START_UPDATE_LOBBY_CUSTOM: {
            console.log("ON_START_UPDATE_LOBBY_CUSTOM", action.payload)
            return {
              ...state,
            }
          }
          case ON_UPDATE_LOBBY_CUSTOM: {
            console.log("ON_UPDATE_LOBBY_CUSTOM", action.payload)
            return {
              ...state,
              MyLobby:action.payload.MyLobby,
            }
          }
          case ON_ERROR_UPDATE_LOBBY_CUSTOM: {
            console.log("ON_ERROR_UPDATE_LOBBY_CUSTOM", action.payload)
            return {
              ...state,
            }
          }
        //MyLobby
        default: return state;
    }
}

